import { render, staticRenderFns } from "./AuthOtpValidateComponent.vue?vue&type=template&id=7cd8fc58&scoped=true"
import script from "./AuthOtpValidateComponent.vue?vue&type=script&lang=js"
export * from "./AuthOtpValidateComponent.vue?vue&type=script&lang=js"
import style0 from "./AuthOtpValidateComponent.vue?vue&type=style&index=0&id=7cd8fc58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd8fc58",
  null
  
)

export default component.exports